/// <amd-module name="Search/Code/Flux/Stores/ZeroDataStore" />

import * as BaseZeroDataStore from "Search/Shared/Base/Stores/ZeroDataStore";
import { IVssPageContext } from "VSS/Platform/Context";
import { SearchQuery, CodeQueryResponse, CodeResult } from "Search/LegacyWebApi/Contracts/Code";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { areQueriesSame, getInitialTake } from "Search/Code/Utils";

export class ZeroDataStore extends BaseZeroDataStore.ZeroDataStore {
    constructor(changedEventName: string, private readonly pageContext: IVssPageContext, data?: ISeedData<CodeResult>) {
        super(changedEventName);
        if (data && data.responseWithActivityId) {
            this.updateStoreState(data.responseWithActivityId.response as CodeQueryResponse, false);
        }
    }

    public onResultsLoaded(
        query: SearchQuery,
        payload: IResultsLoadedPayload<CodeQueryResponse, CodeResult>,
        fetchMoreScenario: boolean): void {
        if (areQueriesSame(query, payload.response.query)) {
            this.updateStoreState(payload.response, fetchMoreScenario);
        }
    }

    protected areQueriesSame(queryInState: SearchQuery, queryInPayload: SearchQuery): boolean {
        return areQueriesSame(queryInState, queryInPayload);
    }

    private updateStoreState = (response: CodeQueryResponse, fetchMoreScenario: boolean): void => {
        if (response && response.results.values.length <= 0) {
            this._state.scenario = BaseZeroDataStore.getScenario(
                response.errors,
                response.results.count,
                getInitialTake(this.pageContext),
                fetchMoreScenario);
        }
    }
}